import { Link } from "react-router-dom";
const ViasTabs = (props) => {
  return (
    <ul
      className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3"
      role="tablist"
    >
      <li className="nav-item" role="presentation">
        <Link
          to={"/visa/search"}
          className={
            props.pageName === "VISASEARCH"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          SEARCH
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/visarequests"}
          className={
            props.pageName === "VISAORDERS"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          ORDERS
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/visarequestreport"}
          className={
            props.pageName === "VISA REQUEST REPORTS"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          ORDERS REPORT
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/visasupplierreport"}
          className={
            props.pageName === "VISA SUPPLIER REPORTS"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          SUPPLIER REPORT
        </Link>
      </li>

      {/* <li className="nav-item" role="presentation">
        <Link
          to={"/pendingPayments"}
          className={
            props.pageName === "VISAPAYMENTS"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          PAYMENTS
        </Link>
      </li> */}
    </ul>
  );
};

export default ViasTabs;
